import React, { Component } from 'react'
import style from './style.module.less'
export default class extends Component {
  static defaultProps = {
    content: '',
    type: '',
    btn1: '',
    btn2: '',
    isShow: '',
    hrefVal: ''
  }

  render() {
    const { content, type, btn1, btn2, isShow, hrefVal, onClick } = this.props

    return (
      <div>
        {isShow ? (
          <div className={style.tipBox} style={{ zIndex: 1000 }}>
            <div className={style.tip2}>
              <div className={style.cont}>{content}</div>
              <div className={style.btnBox}>
                {type == 1 && <button onClick={onClick}>{btn1}</button>}
                {type == 2 && (
                  <span>
                    <button onClick={onClick}>{btn1}</button>
                    <button>
                      <a href={hrefVal}>{btn2}</a>
                    </button>
                  </span>
                )}
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    )
  }
}
